import { every, get, zipObject } from "lodash";
import isEmpty from "lodash/isEmpty";
import { FeedbackData } from "../fields/fields.types";
import { AllFieldTypes } from "../types/feedbackFields.types";

export function isValidField(field: AllFieldTypes, data: FeedbackData) {
  const { type, required, _id, name } = field;

  if (type === "title" || type === "text" || !required) {
    return true; // Always valid, nothing to do :)
  }

  switch (type) {
    case "matrix": {
      return every(field.lines, (line) => !isEmpty(get(data, line._id || line.text)));
    }
    case "image":
    case "rating":
    case "scale": {
      const value = get(data, _id || name);
      return !!value || value === 0;
    }
    default: {
      const value = get(data, _id || name);
      return !isEmpty(value);
    }
  }
}

export function computeFieldErrors(fields: AllFieldTypes[], data: FeedbackData) {
  const fieldErrors = fields.filter((f) => !isValidField(f, data));
  return zipObject(
    fieldErrors.map((f) => f._id || f.name),
    fieldErrors.map(() => true)
  );
}
